import * as React from "react"
import Layout from "../components/Layout"
import Seo from "../components/SEO"
import BannerModule from "../components/BannerModule/BannerModule"
import BasicTextModule from "../components/BasicTextModule/BasicTextModule"
import OfferingTeaser from "../components/Offering/OfferingTeaser"
import LatestPosts from "../components/Post/LatestPosts"
import LatestPostsThree from "../components/Post/LatestPostsThree"
import Reveal from "../components/Reveal/Reveal"

const Index = () => {
  return (
    <>
      <Seo title="Home" />
      <Layout>
        <BannerModule
          eyebrow="Dynamic Web Partners"
          title="A website that makes a strong first impression"
          subTitle="Custom-built from scratch for performers, artists, and creatives — designed to look effortless on every screen."
          ctaText="Explore custom websites"
          ctaTo="/custom-websites"
        />
        <Reveal>
          <BasicTextModule
            eyebrow="Who we are"
            title="In the digital age, a strong online presence isn’t optional — it’s everything."
            content="Welcome to Dynamic Web Partners. We design and build custom websites from scratch — never templates — for performers, artists, and creatives who want to stand out. From the first sketch to launch day, we make the whole process feel effortless."
            link="/custom-websites"
            linkText="See what’s included"
          />
        </Reveal>
        <Reveal>
          <OfferingTeaser />
        </Reveal>
        <Reveal>
          <LatestPosts
            title="Not tech-savvy? No problem"
            introduction="From building your site to ongoing support, our team handles the technical side so you can focus on your craft — clear communication, no jargon, no stress."
          />
        </Reveal>
        <Reveal>
          <LatestPostsThree
            title="Have questions?"
            introduction="We’d love to hear about your project. Reach out and let’s talk about how Dynamic Web Partners can bring your vision to life."
          />
        </Reveal>
      </Layout>
    </>
  )
}

export default Index
